import { errorsFactory } from '../../components/utils';

const FileScanTimeoutError = errorsFactory('FileScanTimeoutError');

export default FileScanTimeoutError;
